import { Component, Prop, Vue } from 'vue-property-decorator';
import OffersApi from '@/services/rest/bemob/offer';
import CreateCampaignDialogCountryMixin from '@/views/reports/mixins/flow/create-campaign-dialog-country-mixin';
import LandingsAPI from '@/services/rest/bemob/landing';

@Component
export default class FlowMixin extends CreateCampaignDialogCountryMixin {
  @Prop()
  offerOptions: Offer[];

  @Prop()
  landingOptions: Landing[];
  
  @Prop()
  landing: any;

  @Prop()
  offer: any; 

  @Prop()
  path: any; 

  @Prop()
  form: any;
  
  offersApi: OffersApi = new OffersApi();
  landingsApi: LandingsAPI = new LandingsAPI();

  get fetchOfferOptions(){
    const { countryId } = this.form;
    if(this.$store.state.cache.offers.isAllInCache){
      return 
    }
    return ({ search })=>this.offersApi.getList({
      search:search,
      status:'active',
      limit:'200',
      orderBy:'updated',
      ...(countryId&& { countryId }),
      orderDirection:'desc',
      columns:[ 'id', 'name' , 'countryId', 'affiliateNetworkId' ,'affiliateNetworkName', 'countryName', 'url'],
      workspaceId:this.form.workspaceId
    })
  }

  get fetchLandingOptions(){
    const { countryId } = this.form;
    if(this.$store.state.cache.landings.isAllInCache){
      return
    }
    return ({ search })=>this.landingsApi.getList({
      search:search,
      status:'active',
      ...(countryId&& { countryId }),
      limit:'200',
      orderBy:'updated',
      orderDirection:'desc',
      columns:[ 'id', 'name', 'countryId', 'offers', 'url'],
      tagsOff:1,
      workspaceId:this.form.workspaceId
    })
  } 
 
  get currentOffersCount() {
    return this.path.offers.length;
  }
}
